import React,{Component} from 'react';
import {LoginBtn, LoginPopup, PopupWindow, SearchBtn, SearchContainer, SearchPopup} from "../../components";
import {Link} from "react-router-dom";
import "../../scss/style-dark.scss"
import {NavigationDark} from "../../components/Navigation/NavigationDark";
import {UserPage} from "../../components/UserPage/UserPage";
import BLACK_LOGO from "../../assets/icons/black-logo.svg";
import {IosAndroidBtn} from "../../components/IosAndroidBtn/IosAndroidBtn";


class Dark extends Component{

  constructor() {
    super();
      this.state={
        page: ""
      }
      document.body.classList.remove("light");
      document.body.classList.add("dark");
  }

  componentDidMount() {
    this.setState({
      page: this.props.match.params.page
    })
    console.log(this.state.page)
  }

  render() {
    return (
      <div className="page-wrapper dark">
        <section className="side-bar">
          <div className="side-part">
            <Link id="logo" to={"/dark"}  style={{backgroundImage: `url(${BLACK_LOGO})`}} />
            <LoginBtn/>
          </div>
          <div className="side-part">
           {/* <a className="rotated-text" id="instagram" href={"https://www.instagram.com/basssiani/"} target={"_blank"}>INSTAGRAM</a>
            <a className="rotated-text" id="facebook"  href={"https://www.facebook.com/bassiani"} target={"_blank"}>FACEBOOK</a>
            */}
            <IosAndroidBtn/>
            <SearchBtn/>
            <Link id="ply" to={"/light"}/>
            <Link id="inf" to={"/dark/contact/house-rules"}/>

          </div>
        </section>
        <section className="main-container">
          {
            this.state.page==='user'? <UserPage/>:<NavigationDark params={this.props.match.params}/>
          }
        </section>
        <SearchContainer/>
        <PopupWindow />
        <LoginPopup/>
        <SearchPopup/>
      </div>
    )
  }
}
export default Dark;
